<template>
  <div class="data-analysis-outer">
    <BlockTitle title="溢价率、竞价率分析" />
    <div id="chartDom" class="chart-canvas" />
  </div>
</template>

<script>
import BlockTitle from '@/views/public_0983cc/tradeData/components/public/BlockTitle.vue'
import {
  data_v2_rate
} from '@/api/portal'
import { mapGetters } from 'vuex'

export default {
  components: {
    BlockTitle
  },
  data() {
    return {
      chartInstance: null,
      chartData: []
    }
  },
  computed: {
    ...mapGetters(['selectLocId']),
    chartDom() {
      return document.getElementById('chartDom')
    },
    charOption() {
      return {
        grid: {
          height: '70%',
          top: 60
        },
        legend: {
          top: 10,
          data: [
            {
              name: '竞价率',
              itemStyle: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                    offset: 0, color: '#00FCFF' // 0% 处的颜色
                  }, {
                    offset: 1, color: '#0075FF' // 100% 处的颜色
                  }]
                }
              },
              textStyle: {
                color: '#fff'
              }
            },
            {
              name: '溢价率',
              textStyle: {
                color: '#fff'
              },
              itemStyle: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                    offset: 0, color: '#FF7A00' // 0% 处的颜色
                  }, {
                    offset: 1, color: '#FFF7D2' // 100% 处的颜色
                  }]
                }
              }
            }
          ]
        },
        tooltip: {
          backgroundColor: 'rgba(51,51,51,.8)',
          textStyle: {
            color: '#fff'
          },
          borderColor: 'transparent',
          trigger: 'axis',
          axisPointer: {
            type: 'line',
            lineStyle: {
              type: 'solid' // 实线
            }
          }
        },
        dataset: {
          source: {
            'timeline': this.chartData.map(i => i.name),
            '竞价率': this.chartData.map(i => i.auctionRate.toFixed(2)),
            '溢价率': this.chartData.map(i => i.premiumRate.toFixed(2))
          }
        },
        xAxis: [
          {
            type: 'category',
            axisLabel: {
              color: '#fff'
            },
            boundaryGap: false // 不留白，从原点开始
          }
        ],
        yAxis: {
          axisLabel: {
            color: '#fff'
          }
        },
        series: [
          {
            type: 'line',
            name: '竞价率',
            barWidth: 10,
            barGap: '80%',
            itemStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0, color: '#00FCFF' // 0% 处的颜色
                }, {
                  offset: 1, color: '#0075FF' // 100% 处的颜色
                }]
              }
            },
            smooth: true,
            smoothMonotone: 'x',
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0, color: '#00FCFF' // 0% 处的颜色
                }, {
                  offset: 1, color: 'rgba(0,0,0,.2)' // 100% 处的颜色
                }]
              }
            },
            label: {
              show: false,
              position: 'top',
              color: '#fff'
            },
            tooltip: {
              valueFormatter: (value) => value + '%'
            },
            showAllSymbol: true
          },
          {
            type: 'line',
            name: '溢价率',
            barWidth: 10,
            itemStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0, color: '#FF7A00' // 0% 处的颜色
                }, {
                  offset: 1, color: '#FFF7D2' // 100% 处的颜色
                }]
              }
            },
            smooth: true,
            smoothMonotone: 'x',
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0, color: '#FF7A00' // 0% 处的颜色
                }, {
                  offset: 1, color: 'rgba(0,0,0,.2)' // 100% 处的颜色
                }]
              }
            },
            label: {
              show: false,
              position: 'top',
              color: '#fff'
            },
            tooltip: {
              valueFormatter: (value) => value + '%'
            },
            showAllSymbol: true
          }
        ]
      }
    }
  },
  watch: {
    async selectLocId() {
      await this.getRate()
      this.chartInstance.setOption(this.charOption)
    }
  },
  created() {
  },
  async mounted() {
    await this.getRate()
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    initChart() {
      this.chartInstance = echarts.init(this.chartDom)
      this.chartInstance.setOption(this.charOption)
    },
    // 获取竞价率及溢价率
    async getRate() {
      const { data } = await data_v2_rate({
        locId: this.selectLocId
      })
      this.chartData = data
    }
  }
}
</script>

<style lang="scss" scoped>
.chart-canvas{
  width: 100%;
  height: 310px;
}
</style>
